<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path d="M12,22h8v4H12Z" />
    <path d="M6,14H26v4H6Z" />
    <path d="M0,6H32v4H0Z" />
</svg>
